export default "__VITE_ASSET__Bi7LcBbH__"